import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Bar Chart panel art: four measures shown twice over, one bar in the accent
 * for period A and one muted for period B, standing on a shared baseline with a
 * two swatch key above.
 */

const BASELINE = 80

/** [group left x, period A height, period B height] */
const GROUPS: [number, number, number][] = [
  [12, 44, 32],
  [46, 54, 38],
  [80, 28, 42],
  [114, 38, 24],
]

export function BarChartArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      {/* Key: accent period, then muted period. */}
      <rect x={12} y={12} width={8} height={6} rx={2} fill="hsl(var(--primary) / 0.7)" />
      <rect x={24} y={13} width={22} height={4} rx={2} fill="hsl(var(--foreground) / 0.14)" />
      <rect x={56} y={12} width={8} height={6} rx={2} fill="hsl(var(--muted-foreground) / 0.5)" />
      <rect x={68} y={13} width={22} height={4} rx={2} fill="hsl(var(--foreground) / 0.14)" />
      {GROUPS.map(([x, heightA, heightB]) => (
        <g key={x}>
          <rect
            x={x + 4}
            y={BASELINE - heightA}
            width={11}
            height={heightA}
            rx={2}
            fill="hsl(var(--primary) / 0.7)"
          />
          <rect
            x={x + 17}
            y={BASELINE - heightB}
            width={11}
            height={heightB}
            rx={2}
            fill="hsl(var(--muted-foreground) / 0.45)"
          />
          <rect
            x={x + 7}
            y={84}
            width={18}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
        </g>
      ))}
      <path
        d={`M12 ${BASELINE} H148`}
        stroke="hsl(var(--muted-foreground) / 0.4)"
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  )
}
